/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Button, Input, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, Pagination, Popover, PopoverContent, PopoverTrigger, Select, SelectItem, Slider, Spinner, Table, TableBody, TableCell, TableColumn, TableHeader, TableRow, User } from '@nextui-org/react';
import { IconDownload, IconEye, IconMapPin } from '@tabler/icons-react';
import toast from 'react-hot-toast';
import { Constants, formatNumber, fromPhotos, groupBySubject } from '../../../utils';
import DebouncedSearch from '../../../components/input-debounce';
import { SchoolService, UsersService } from '../../../services';
import { useSelector } from 'react-redux';
import generateConductPDF from './conduct-pdf';
import { generateAttendancePDF, generateQualificationsPDF, generateStudentPDF } from './student-pdf';
import Render from '../../../components/render';
import PaidAction from '../../../components/paid-action';

const TYPE = {
  MAIN: 1,
  QUALIFICATIONS: 2,
  ASSISTS: 3,
  CONDUCT: 4,
  QUALIFICATIONS_BY_SECTION: 5,
  CERTIFICATION: 6,
}

const MODAL_ACTION = {
  NONE: 0,
  VIEW_EVALUATIONS: 1,
  REMOVE_STUDENT: 2
}

const GENERATE_PDF = {
  STUDENT: 1,
  ATTENDENCE: 2,
  QUALIFICATIONS: 3,
  QUALIFICATIONS_BY_SECTION: 4,
  CERTIFICATION: 5,
  CERTIFICATION_NOTES: 6,
}


const approvedStatus = [
  { value: Constants.APPROVED_STATUS.FAILED, label: 'Reprobado' },
  { value: Constants.APPROVED_STATUS.APPROVED, label: 'Aprobado' },
]


const Students = () => {
  const [selectedItem, setSelectedItem] = useState();
  const [modalAction, setModalAction] = useState(MODAL_ACTION.NONE);

  const { canResetFilter, data, filters, filterBy, studentGrades, isLoading, schoolLapses, reload, schoolYears, studentSections, user, getStudentScore, setFilters } = useFetchTable();
  const { resetFilter, qualifications, qualificatioFilters, loading, onFilter, paginated, reloadQualifications, toPage, years, grades, sections, lapses, deleteStudent, changeStatus, changeGrade, downloadQualifications, downloadCertification, downloadQualificationsCertified } = useQualificationsTable()

  const onSelectItem = (item, action) => {
    setSelectedItem(item);
    setModalAction(action);
  }

  const closeModal = (reloading = false) => {
    setSelectedItem(null);
    setModalAction(MODAL_ACTION.NONE);
    if (reloading) reloadQualifications();
  }

  const downloadPdf = async (type) => {
    const school_year = schoolYears.find(x => +x.id === +filters.year)?.name
    const school_grade = studentGrades.find(x => +x.id === +filters.grade)?.name
    const school_section = studentSections.find(x => +x.id === +filters.section)?.name
    const school_lapse = schoolLapses.find(x => +x.id === +filters.lapse)?.name

    const student = [data.student];
    const filtersPDF = {
      school_year,
      school_grade,
      school_section,
      school_lapse
    }

    if (type === GENERATE_PDF.STUDENT) {
      const parents = data.parents;
      generateStudentPDF(student, parents, filtersPDF)
    }

    if (type === GENERATE_PDF.ATTENDENCE) {
      generateAttendancePDF([data.assist], filtersPDF)
    }

    if (type === GENERATE_PDF.QUALIFICATIONS) {
      const subjects = data.qualifications.subjects.map((x) => x.id)
      const studentId = data.student.id

      const res = await getStudentScore({ student_id: studentId, subjects_ids: subjects })
      const groupBY = groupBySubject(res)
      const mappedData = groupBY.map((item) => {
        const match = data.qualifications.subjects.find(x => x.id === item.subject_id)

        return {
          ...item,
          evaluated: match.evaluated,
          total_pond: match.total_pond,
          score: match.score,
          total_pond_avg: match.total_pond_avg,
          total_pond_desc: match.total_pond_desc,
        }
      })
      generateQualificationsPDF(student, {
        ...filtersPDF,
        maxQuantitativeScale: data.qualifications.maxQuantitativeScale,
        subjects: mappedData
      })
    }

    if (type === GENERATE_PDF.QUALIFICATIONS_BY_SECTION) {
      downloadQualifications();
    }

    if (type === GENERATE_PDF.CERTIFICATION) {
      downloadCertification();
    }

    if (type === GENERATE_PDF.CERTIFICATION_NOTES) {
      downloadQualificationsCertified();
    }
  }

  return (
    <div>
      {(isLoading || loading) && (
        <div className="w-screen h-screen fixed inset-0 z-[70] flex justify-center items-center bg-white/30">
          <Spinner />
        </div>
      )}

      <Modal
        size="2xl"
        isOpen={modalAction !== MODAL_ACTION.NONE}
        onClose={() => closeModal()}
        backdrop="blur"
        scrollBehavior="outside"
      >
        <ModalContent>
          {(onClose) => {
            if (modalAction === MODAL_ACTION.VIEW_EVALUATIONS) return (
              <ModalViewEvaluations data={selectedItem} onFetchData={getStudentScore} />
            );
            if (modalAction === MODAL_ACTION.REMOVE_STUDENT) return (
              <ModalDelete
                user={selectedItem}
                onClose={onClose}
                onDelete={() => {
                  deleteStudent(selectedItem?.student_id);
                  closeModal(true);
                }}
              />
            );
          }}
        </ModalContent>
      </Modal>

      {
        filters.type === TYPE.QUALIFICATIONS_BY_SECTION && (
          <QualificationFilters
            onFilter={onFilter}
            canResetFilters={resetFilter}
            resetFilter={() => reloadQualifications()}
            grades={grades}
            sections={sections}
            schoolYears={years}
          />
        )
      }

      {
        filters.type === TYPE.CERTIFICATION && (
          <Filters
            canResetFilters={resetFilter}
            filterBy={onFilter}
            canResetFilter={canResetFilter}
            resetFilter={() => reloadQualifications()}
            grades={grades}
            sections={sections}
            schoolYears={years}
            lapses={lapses}
            user={user}
          />
        )
      }

      {
        [TYPE.ASSISTS, TYPE.CONDUCT, TYPE.MAIN, TYPE.QUALIFICATIONS].includes(filters.type) && (
          <Filters
            canResetFilter={canResetFilter}
            filterBy={filterBy}
            resetFilter={() => reload()}
            schoolYears={schoolYears}
            grades={studentGrades}
            sections={studentSections}
            lapses={schoolLapses}
            user={user}
          />
        )
      }


      <div className="mb-4 flex flex-row justify-center gap-4 [&>button]:font-semibold [&>button]:text-white">
        <Button
          variant="flat"
          radius="sm"
          className={filters.type === TYPE.MAIN ? 'bg-green' : 'bg-primary'}
          onPress={() => filterBy(TYPE.MAIN, 'type')}
        >
          Informe de estudiante
        </Button>
        <Button
          variant="flat"
          radius="sm"
          className={filters.type === TYPE.ASSISTS ? 'bg-green' : 'bg-primary'}
          onPress={() => filterBy(TYPE.ASSISTS, 'type')}
        >
          Informe de asistencia
        </Button>
        <Button
          variant="flat"
          radius="sm"
          className={filters.type === TYPE.QUALIFICATIONS ? 'bg-green' : 'bg-primary'}
          onPress={() => filterBy(TYPE.QUALIFICATIONS, 'type')}
        >
          Calificaciones
        </Button>
        <Button
          variant="flat"
          radius="sm"
          className={filters.type === TYPE.CONDUCT ? 'bg-green' : 'bg-primary'}
          onPress={() => filterBy(TYPE.CONDUCT, 'type')}
        >
          Informe de conducta
        </Button>
        <Button
          variant="flat"
          radius="sm"
          className={filters.type === TYPE.CERTIFICATION ? 'bg-green' : 'bg-primary'}
          onPress={() => {
            setFilters({
              page: 1,
              perPage: Constants.PER_PAGE,
              name: '',
              year: '',
              grade: '',
              section: '',
              student_id: '',
              lapse: '',
              type: TYPE.CERTIFICATION,
            })
          }}
        >
          Boleta / Certificación de calificación
        </Button>
        <Button
          variant="flat"
          radius="sm"
          className={filters.type === TYPE.QUALIFICATIONS_BY_SECTION ? 'bg-green' : 'bg-primary'}
          onPress={() => {
            setFilters({
              page: 1,
              perPage: Constants.PER_PAGE,
              name: '',
              year: '',
              grade: '',
              section: '',
              student_id: '',
              lapse: '',
              type: TYPE.QUALIFICATIONS_BY_SECTION,
            })
          }}
        >
          Informe anual de calificaciones
        </Button>
      </div>

      {filters.type === TYPE.MAIN && (
        <div className="shadow-small rounded-large">
          <Table
            aria-label="Estudiante"
            color="primary"
            classNames={{ wrapper: '!rounded-b-none shadow-none' }}
            topContentPlacement="inside"
            topContent={
              <div className="flex flex-row justify-between items-center gap-4">
                <h3 className="text-xl font-medium">Estudiante</h3>
                <Render condition={!!data?.student && data?.parents}>
                  <PaidAction>
                    <Button
                      className="bg-primary text-white"
                      startContent={<IconDownload size={17} />}
                      onPress={() => downloadPdf(GENERATE_PDF.STUDENT)}
                    >
                      Descargar
                    </Button>
                  </PaidAction>
                </Render>
              </div>
            }
          >
            <TableHeader>
              <TableColumn>Nombre</TableColumn>
              <TableColumn>DNI/C.I</TableColumn>
              <TableColumn>Grado</TableColumn>
              <TableColumn>Sección</TableColumn>
              <TableColumn>Teléfono</TableColumn>
              <TableColumn>Domicilio</TableColumn>
            </TableHeader>
            <TableBody items={!!data?.student ? [data?.student] : []} emptyContent="No hay resultados" isLoading={isLoading}>
              {(user) => {
                return (
                  <TableRow key={user.id}>
                    <TableCell>
                      <User
                        avatarProps={{ showFallback: true, radius: 'full', src: user?.photo ? fromPhotos(user.photo) : null }}
                        description={user.email}
                        name={user?.fullname}
                        classNames={{ description: 'text-foreground-500' }}
                      />
                    </TableCell>
                    <TableCell>{user?.document_type?.name}{user.document}</TableCell>
                    <TableCell>{studentGrades.find(x => x.value === filters.grade)?.label}</TableCell>
                    <TableCell>{studentSections.find(x => x.value === filters.section)?.label}</TableCell>
                    <TableCell>{user?.phonecode?.name}{user.phone}</TableCell>
                    <TableCell>
                      {!!user?.address && (
                        <Popover placement="top" color="default" radius="sm">
                          <PopoverTrigger>
                            <IconMapPin className="text-secondary cursor-pointer" />
                          </PopoverTrigger>
                          <PopoverContent>
                            <div className="p-1 text-small">{user?.address}</div>
                          </PopoverContent>
                        </Popover>
                      )}
                    </TableCell>
                  </TableRow>
                )
              }}
            </TableBody>
          </Table>
          <Table
            aria-label="Representantes"
            color="primary"
            classNames={{ wrapper: '!rounded-t-none shadow-none' }}
            topContentPlacement="inside"
            topContent={
              <div className="flex flex-row justify-between items-center gap-4">
                <h3 className="text-xl font-medium">Representantes</h3>
              </div>
            }
          >
            <TableHeader>
              <TableColumn>Nombre</TableColumn>
              <TableColumn>DNI/C.I</TableColumn>
              <TableColumn>Teléfono</TableColumn>
              <TableColumn>Parentesco</TableColumn>
              <TableColumn>Domicilio</TableColumn>
            </TableHeader>
            <TableBody items={data?.parents ?? []} emptyContent="No hay resultados" isLoading={isLoading}>
              {(user) => {
                return (
                  <TableRow key={user?.parent?.id}>
                    <TableCell>
                      <User
                        avatarProps={{ showFallback: true, radius: 'full', src: user?.parent?.photo ? fromPhotos(user.parent.photo) : null }}
                        description={user?.parent.email}
                        name={user?.parent?.fullname}
                        classNames={{ description: 'text-foreground-500' }}
                      />
                    </TableCell>
                    <TableCell>{user?.parent?.document_type?.name}{user.parent.document}</TableCell>
                    <TableCell>{user?.parent?.phonecode?.name}{user.parent.phone}</TableCell>
                    <TableCell>{user?.relationship?.name}</TableCell>
                    <TableCell>
                      {!!user?.parent?.address && (
                        <Popover placement="top" color="default" radius="sm">
                          <PopoverTrigger>
                            <IconMapPin className="text-secondary cursor-pointer" />
                          </PopoverTrigger>
                          <PopoverContent>
                            <div className="p-1 text-small">{user?.parent?.address}</div>
                          </PopoverContent>
                        </Popover>
                      )}
                    </TableCell>
                  </TableRow>
                )
              }}
            </TableBody>
          </Table>
        </div>
      )}

      {filters.type === TYPE.ASSISTS && (
        <Table
          aria-label="Informe de asistencia"
          color="primary"
          topContentPlacement="inside"
          topContent={
            <div className="flex flex-row justify-between items-center gap-4">
              <h3 className="text-xl font-medium">
                {schoolLapses.find(x => x.value === filters.lapse)?.label}
              </h3>
              <Render condition={!!data?.assist}>
                <PaidAction>
                  <Button
                    className="bg-primary text-white"
                    startContent={<IconDownload size={17} />}
                    onPress={() => downloadPdf(GENERATE_PDF.ATTENDENCE)}
                  >
                    Descargar
                  </Button>
                </PaidAction>
              </Render>

            </div>
          }
        >
          <TableHeader>
            <TableColumn>Nombre</TableColumn>
            <TableColumn>Grado</TableColumn>
            <TableColumn>Sección</TableColumn>
            <TableColumn>Total Días Escolares</TableColumn>
            <TableColumn>Días Asistencia</TableColumn>
            <TableColumn>Días de Inasistencia</TableColumn>
          </TableHeader>
          <TableBody
            items={!!data?.assist ? [data.assist] : []}
            emptyContent="No hay resultados"
            isLoading={isLoading}
          >
            {(item) => {
              return (
                <TableRow key={'assists'}>
                  <TableCell>{item?.fullName}</TableCell>
                  <TableCell>{studentGrades.find(x => x.value === filters.grade)?.label}</TableCell>
                  <TableCell>{studentSections.find(x => x.value === filters.section)?.label}</TableCell>
                  <TableCell>{item.schoolDays}</TableCell>
                  <TableCell>{item.assistDays}</TableCell>
                  <TableCell>{item.inassistDays}</TableCell>
                </TableRow>
              )
            }}
          </TableBody>
        </Table>
      )}

      {filters.type === TYPE.QUALIFICATIONS && (
        <Table
          aria-label="Calificaciones"
          color="primary"
          topContentPlacement="inside"
          bottomContentPlacement="inside"
          topContent={
            <div className="flex flex-row justify-between items-center gap-4">
              <h3 className="text-xl font-medium capitalize">
                {schoolLapses.find(x => x.value === filters.lapse)?.label}
              </h3>
              <Render condition={data?.qualifications}>
                <PaidAction>
                  <Button
                    className="bg-primary text-white"
                    startContent={<IconDownload size={17} />}
                    onPress={() => downloadPdf(GENERATE_PDF.QUALIFICATIONS)}
                  >
                    Descargar
                  </Button>
                </PaidAction>
              </Render>
            </div>
          }
          bottomContent={
            <Table aria-label="Materias" removeWrapper>
              <TableHeader>
                <TableColumn>Materia</TableColumn>
                <TableColumn className="text-center">Calificación promedio</TableColumn>
                <TableColumn className="text-center">Nota acumulada</TableColumn>
                <TableColumn className="text-center">Descripción</TableColumn>
                <TableColumn className="text-right">Porcentaje evaluado</TableColumn>
              </TableHeader>
              <TableBody items={data?.qualifications?.subjects ?? []}>
                {(subject) => {
                  const percentaje = subject.evaluated
                  return (
                    <TableRow key={subject.id} className="bg-default-100 border-b-1 border-b-default-300 last:border-none">
                      <TableCell className='capitalize'>{subject.name}</TableCell>
                      <TableCell className="text-center">{ subject.total_pond_avg }</TableCell>
                      <TableCell className="text-center">
                        { subject.total_pond } / { data?.qualifications?.maxQuantitativeScale }
                      </TableCell>
                      <TableCell className="text-center">{ subject.total_pond_desc || '' }</TableCell>
                      <TableCell className="flex gap-4 justify-end">
                        <Slider
                          aria-label="Porcentaje"
                          className="w-40"
                          size="md"
                          maxValue={100}
                          defaultValue={percentaje}
                          value={percentaje}
                          hideThumb
                          hideValue
                          color="success"
                          endContent={<div className="w-8 font-semibold text-right">{percentaje}%</div>}
                        />

                        <IconEye
                          className="cursor-pointer ml-5"
                          onClick={() => onSelectItem({ student_id: data?.qualifications?.student_id, subject }, MODAL_ACTION.VIEW_EVALUATIONS)}
                        />
                      </TableCell>
                    </TableRow>
                  )
                }}
              </TableBody>
            </Table>
          }
        >
          <TableHeader>
            <TableColumn>Nombre</TableColumn>
            <TableColumn>DNI/C.I</TableColumn>
            <TableColumn>Grado</TableColumn>
            <TableColumn>Sección</TableColumn>
            <TableColumn>Promedio de Notas</TableColumn>
          </TableHeader>
          <TableBody
            items={!!data?.qualifications ? [data.qualifications] : []}
            emptyContent="No hay resultados"
            isLoading={isLoading}
          >
            {(item) => (
              <TableRow key={'qualifications'}>
                <TableCell>{item?.fullName}</TableCell>
                <TableCell>{item.document}</TableCell>
                <TableCell>{studentGrades.find(x => x.value === filters.grade)?.label}</TableCell>
                <TableCell>{studentSections.find(x => x.value === filters.section)?.label}</TableCell>
                <TableCell className="text-lg font-bold text-primary">{ item.qualificationsAvg }</TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      )}

      {filters.type === TYPE.CONDUCT && (
        <Table
          aria-label="Informe de conducta"
          color="primary"
          topContentPlacement="inside"
          topContent={
            <div className="flex flex-row justify-between items-center gap-4">
              <h3 className="text-xl font-medium">Datos</h3>
            </div>
          }
          bottomContent={
            <div className="flex justify-center">
              <Button
                variant="flat"
                radius="sm"
                className="bg-green text-white font-semibold"
                isDisabled={!data?.conduct}
                onClick={() => {
                  if (data?.conduct) {
                    generateConductPDF(data.conduct.data)
                  }
                }}
              >
                Generar
              </Button>
            </div>
          }
        >
          <TableHeader>
            <TableColumn>Nombre</TableColumn>
            <TableColumn>DNI/C.I</TableColumn>
            <TableColumn>Grado</TableColumn>
            <TableColumn>Sección</TableColumn>
            <TableColumn>Nombre del Director</TableColumn>
            <TableColumn>Municipio</TableColumn>
          </TableHeader>
          <TableBody
            items={!!data?.conduct ? [data?.conduct] : []}
            emptyContent="No hay resultados"
            isLoading={isLoading}
          >
            {(item) => {
              console.log(item);
              return (
                <TableRow key={item?.fullName}>
                  <TableCell className='capitalize'>{item?.fullName}</TableCell>
                  <TableCell>{item?.document}</TableCell>
                  <TableCell>{studentGrades.find(x => x.value === filters.grade)?.label}</TableCell>
                  <TableCell>{studentSections.find(x => x.value === filters.section)?.label}</TableCell>
                  <TableCell className='capitalize'>{item?.director}</TableCell>
                  <TableCell className='capitalize'>{item?.municipality}</TableCell>
                </TableRow>
              )
            }}
          </TableBody>
        </Table>
      )}

      {filters.type === TYPE.CERTIFICATION && (
        <Table
          aria-label="Boleta / Certificación de calificación"
          color="primary"
          topContentPlacement="inside"
          topContent={
            <div className="flex flex-row justify-between items-center gap-4">
              <h3 className="text-xl font-medium">
                <p className='capitalize'>{grades.find(x => x.value === qualificatioFilters.grade)?.label} {sections.find(x => x.value === qualificatioFilters.section)?.label}</p>
              </h3>

              {(qualifications?.length > 0 && grades.find(x => x.value === qualificatioFilters.grade)?.type === 3) && (
                <div className="flex gap-4">
                  <PaidAction>
                    <Button
                      className="pr-2 font-medium"
                      variant="bordered"
                      endContent={<IconDownload />}
                      onPress={() => downloadPdf(GENERATE_PDF.CERTIFICATION)}
                    >
                      Boleta
                    </Button>
                  </PaidAction>
                  <PaidAction>
                    <Button
                      className="pr-2 bg-green font-medium text-white"
                      endContent={<IconDownload />}
                      onPress={() => downloadPdf(GENERATE_PDF.CERTIFICATION_NOTES)}
                    >
                      Certificación de calificaciones
                    </Button>
                  </PaidAction>
                </div>
              )}
            </div>
          }
        >
          <TableHeader>
            <TableColumn>Nombre</TableColumn>
            <TableColumn>DNI/C.I</TableColumn>
            {
              lapses.map(x => (
                <TableColumn className='capitalize' key={x.value}>
                  <p className='text-xs'>Promedio</p>
                  <p className='text-xs'>{x.label}</p>
                </TableColumn>
              ))
            }
            <TableColumn>Promedio final</TableColumn>
          </TableHeader>
          <TableBody
            items={!!qualifications ? qualifications : []}
            emptyContent="No hay resultados"
            isLoading={loading}
          >
            {(item) => {
              return (
                <TableRow key={item.student_id}>
                  <TableCell>{item?.student_fullname}</TableCell>
                  <TableCell>{item.student_document}</TableCell>
                  {
                    lapses.map(lapse => {
                      const findLapse = item.lapses.find(x => x.lapse_id === lapse.id);
                      if (!findLapse) return <TableCell key={lapse.value}> -- </TableCell>;

                      return <TableCell key={lapse.value}>{findLapse?.average_text}</TableCell>
                    })
                  }
                  <TableCell>{item?.final_average_text}</TableCell>
                </TableRow>
              )
            }}
          </TableBody>
        </Table>
      )}

      {filters.type === TYPE.QUALIFICATIONS_BY_SECTION && (
        <Table
          aria-label="Informe de conducta"
          color="primary"
          topContentPlacement="inside"
          topContent={
            <div className="flex flex-row justify-between items-center gap-4">
              <h3 className="text-xl font-medium">
                <p className='capitalize'>{grades.find(x => x.value === qualificatioFilters.grade)?.label} {sections.find(x => x.value === qualificatioFilters.section)?.label}</p>
              </h3>

              <PaidAction>
                <Button
                  className="pr-2 bg-green font-medium text-white"
                  endContent={<IconDownload />}
                  onPress={() => downloadPdf(GENERATE_PDF.QUALIFICATIONS_BY_SECTION)}
                >
                  Descargar
                </Button>
              </PaidAction>
            </div>
          }
        >
          <TableHeader>
            <TableColumn>Nombre</TableColumn>
            <TableColumn>DNI/C.I</TableColumn>
            {
              lapses.map(x => (
                <TableColumn className='capitalize' key={x.value}>
                  <p className='text-xs'>Promedio</p>
                  <p className='text-xs'>{x.label}</p>
                </TableColumn>
              ))
            }
            <TableColumn>Promedio final</TableColumn>
            <TableColumn width={200}>Estatus</TableColumn>
            <TableColumn>Promovido a grado</TableColumn>
            <TableColumn></TableColumn>
          </TableHeader>
          <TableBody
            items={!!qualifications ? qualifications : []}
            emptyContent="No hay resultados"
            isLoading={loading}
          >
            {(item) => {
              return (
                <TableRow key={item.student_id}>
                  <TableCell>{item?.student_fullname}</TableCell>
                  <TableCell>{item.student_document}</TableCell>
                  {
                    lapses.map(lapse => {
                      const findLapse = item.lapses.find(x => x.lapse_id === lapse.id);
                      if (!findLapse) return <TableCell key={lapse.value}> -- </TableCell>;

                      return <TableCell key={lapse.value}>{findLapse?.average_text}</TableCell>
                    })
                  }
                  <TableCell>{item?.final_average_text}</TableCell>
                  <TableCell>
                    <Select
                      aria-label="Estatus"
                      variant="bordered"
                      radius="sm"
                      classNames={{
                        label: 'font-semibold',
                        base: 'w-full sm:max-w-[10rem]',
                        trigger: 'border-1',
                      }}
                      selectedKeys={Number.isInteger(item.status) ? [String(item.status)] : []}
                      onSelectionChange={v => changeStatus(item, v.currentKey)}
                    >
                      {approvedStatus.map((item) => (
                        <SelectItem key={item.value} value={item.value}>{item.label}</SelectItem>
                      ))}
                    </Select>
                  </TableCell>
                  <TableCell>
                    <Select
                      aria-label="Promovido a grado"
                      variant="bordered"
                      radius="sm"
                      classNames={{
                        label: 'font-semibold',
                        base: 'w-full sm:max-w-[10rem]',
                        trigger: 'border-1',
                      }}
                      selectedKeys={!!item.next_grade ? [String(item.next_grade)] : []}
                      onSelectionChange={v => changeGrade(item, v.currentKey)}
                    >
                      {grades.filter(x => x.id !== +qualificatioFilters.grade).map((item) => (
                        <SelectItem key={item.value} value={item.value}>{item.label}</SelectItem>
                      ))}
                    </Select>
                  </TableCell>
                  <TableCell>
                    {
                      item?.student_is_active ?
                        <p
                          className='text-secondary cursor-pointer font-bold'
                          onClick={() => onSelectItem(item, MODAL_ACTION.REMOVE_STUDENT)}
                        >
                          Retirar
                        </p>
                        :
                        <p
                          className='text-danger font-bold'
                        >
                          Retirado
                        </p>
                    }
                  </TableCell>
                </TableRow>
              )
            }}
          </TableBody>
        </Table>
      )}

      {
        filters.type === TYPE.QUALIFICATIONS_BY_SECTION && (
          <div className="flex w-full justify-center mt-4">
            <Pagination
              showControls
              variant="bordered"
              page={paginated.page}
              total={paginated.pages}
              onChange={toPage}
            />
          </div>
        )
      }
    </div>
  );
}

const Filters = ({ canResetFilter, filterBy, grades, lapses, resetFilter, schoolYears, sections, user }) => {
  const initialFilter = {
    name: '',
    year: '',
    grade: '',
    section: '',
    lapse: '',
    student_id: '',
    student_name: '',
  };
  const [form, setForm] = useState(initialFilter);

  const onChange = (value, target) => {
    setForm(s => ({ ...s, [target]: value }));
    filterBy(value, target);
  }

  const fetchStudents = async (query) => {
    try {
      const text = query.trim().toLowerCase();
      if (!text) return [];
      const response = await UsersService.school.findStudents({ page: 1, search: text, school_id: user.id });
      const { data } = response;
      return data
    } catch (error) {
      toast.error(String(error) || 'Ocurrió un error inesperado');
    }
  }

  const onSelectStudent = (item) => {
    onChange(item?.fullname, 'student_name');
    onChange(item?.id, 'student_id');
  }

  return (
    <section className="mb-4 grid sm:flex flex-wrap grid-cols-2 lg:flex-row items-end gap-4">
      <div className='w-full sm:max-w-[15rem]'>
        <DebouncedSearch
          label='Nombre/cédula del estudiante'
          placeholder='Nombre o cédula'
          fetchFunction={fetchStudents}
          debounceTime={700}
          onSelect={onSelectStudent}
          renderItem={(item) => `${item.fullname} (${item.document_type?.name}${item.document})`}
          onClickLabel={(item) => `${item.document_type?.name} ${item.document}`}
        />
      </div>
      <Input
        classNames={{
          base: 'w-full sm:max-w-[15rem]',
          inputWrapper: 'border-1 h-10',
        }}
        label="Nombre"
        labelPlacement="outside"
        placeholder=" "
        variant="bordered"
        radius="sm"
        value={form.student_name}
        isDisabled
      />
      <Select
        label="Año escolar"
        labelPlacement="outside"
        placeholder=" "
        variant="bordered"
        radius="sm"
        classNames={{
          label: 'font-semibold',
          base: 'w-full sm:max-w-[10rem]',
          trigger: 'border-1',
        }}
        disallowEmptySelection={true}
        selectedKeys={!!form.year ? [form.year] : []}
        onSelectionChange={v => onChange(v.currentKey, 'year')}
      >
        {schoolYears.map((item) => (
          <SelectItem key={item.value} value={item.value}>{item.label}</SelectItem>
        ))}
      </Select>
      <Select
        label="Grado"
        labelPlacement="outside"
        placeholder=" "
        variant="bordered"
        radius="sm"
        classNames={{
          label: 'font-semibold',
          base: 'w-full sm:max-w-[10rem]',
          trigger: 'border-1',
        }}
        disallowEmptySelection={true}
        selectedKeys={!!form.grade ? [form.grade] : []}
        onSelectionChange={v => onChange(v.currentKey, 'grade')}
      >
        {grades.map((item) => (
          <SelectItem key={item.value} value={item.value}>{item.label}</SelectItem>
        ))}
      </Select>
      <Select
        label="Sección"
        labelPlacement="outside"
        placeholder=" "
        variant="bordered"
        radius="sm"
        classNames={{
          label: 'font-semibold',
          base: 'w-full sm:max-w-[10rem]',
          trigger: 'border-1',
        }}
        disallowEmptySelection={true}
        selectedKeys={!!form.section ? [form.section] : []}
        onSelectionChange={v => onChange(v.currentKey, 'section')}
      >
        {sections.map((item) => (
          <SelectItem key={item.value} value={item.value}>{item.label}</SelectItem>
        ))}
      </Select>
      <Select
        label="Lapso"
        labelPlacement="outside"
        placeholder=" "
        variant="bordered"
        radius="sm"
        classNames={{
          label: 'font-semibold',
          base: 'w-full sm:max-w-[10rem]',
          trigger: 'border-1',
        }}
        disallowEmptySelection={true}
        selectedKeys={!!form.lapse ? [form.lapse] : []}
        onSelectionChange={v => onChange(v.currentKey, 'lapse')}
      >
        {lapses.map((item) => (
          <SelectItem key={item.value} value={item.value}>{item.label}</SelectItem>
        ))}
      </Select>

      {canResetFilter && (
        <Button
          variant="light"
          className="text-primaryDark"
          onPress={() => {
            setForm(initialFilter);
            resetFilter();
          }}
        >
          Limpiar filtros
        </Button>
      )}
    </section>
  )
}

const QualificationFilters = ({ onFilter, resetFilter, grades, sections, schoolYears, canResetFilters }) => {
  const initialFilter = {
    year: '',
    grade: '',
    section: '',
  };

  const [form, setForm] = useState(initialFilter);

  const onChange = (value, target) => {
    setForm(s => ({ ...s, [target]: value }));
    onFilter(value, target);
  }

  return (
    <section className="mb-4 grid sm:flex grid-cols-2 lg:flex-row items-end gap-4">
      <Select
        label="Año escolar"
        labelPlacement="outside"
        placeholder=" "
        variant="bordered"
        radius="sm"
        classNames={{
          label: 'font-semibold',
          base: 'w-full sm:max-w-[10rem]',
          trigger: 'border-1',
        }}
        disallowEmptySelection={true}
        selectedKeys={!!form.year ? [form.year] : []}
        onSelectionChange={v => onChange(v.currentKey, 'year')}
      >
        {schoolYears.map((item) => (
          <SelectItem key={item.value} value={item.value}>{item.label}</SelectItem>
        ))}
      </Select>
      <Select
        label="Grado"
        labelPlacement="outside"
        placeholder=" "
        variant="bordered"
        radius="sm"
        classNames={{
          label: 'font-semibold',
          base: 'w-full sm:max-w-[10rem]',
          trigger: 'border-1',
        }}
        disallowEmptySelection={true}
        selectedKeys={!!form.grade ? [form.grade] : []}
        onSelectionChange={v => onChange(v.currentKey, 'grade')}
      >
        {grades.map((item) => (
          <SelectItem key={item.value} value={item.value}>{item.label}</SelectItem>
        ))}
      </Select>
      <Select
        label="Sección"
        labelPlacement="outside"
        placeholder=" "
        variant="bordered"
        radius="sm"
        classNames={{
          label: 'font-semibold',
          base: 'w-full sm:max-w-[10rem]',
          trigger: 'border-1',
        }}
        disallowEmptySelection={true}
        selectedKeys={!!form.section ? [form.section] : []}
        onSelectionChange={v => onChange(v.currentKey, 'section')}
      >
        {sections.map((item) => (
          <SelectItem key={item.value} value={item.value}>{item.label}</SelectItem>
        ))}
      </Select>


      {canResetFilters && (
        <Button
          variant="light"
          className="text-primaryDark"
          onClick={() => {
            setForm(initialFilter);
            resetFilter();
          }}
        >
          Limpiar filtros
        </Button>
      )}
    </section>
  )

}

const ModalViewEvaluations = ({ data, onFetchData }) => {

  const [details, setDetails] = useState([]);

  const fetchData = async () => {
    const response = await onFetchData({
      student_id: +data.student_id,
      subject_id: +data.subject?.id,
    })
    setDetails(response);
  }

  useEffect(() => {
    fetchData();
  }, []);


  return (
    <>
      <ModalHeader className="flex flex-col gap-1 capitalize">{data?.subject?.name}</ModalHeader>
      <ModalBody className="p-0 pb-4">
        <Table aria-label="Materias" removeWrapper>
          <TableHeader>
            <TableColumn style={{ textWrap: 'wrap' }}>Nombre de la evaluación</TableColumn>
            <TableColumn style={{ textWrap: 'wrap' }}>Tipo de evaluación</TableColumn>
            <TableColumn>Porcentaje</TableColumn>
            <TableColumn>Nota</TableColumn>
            <TableColumn>Nota ponderada</TableColumn>
          </TableHeader>
          <TableBody items={details ?? []} emptyContent="No hay resultados">
            {
              (item) => {
                console.log(item)
                return (
                  (
                    <TableRow className="border-b-1 border-b-default-300 last:border-none [&>td]:bg-default-100">
                      <TableCell>{item?.name}</TableCell>
                      <TableCell>
                        {
                          item.subject_type_qualification == Constants.SUBJECTS.TYPE_QUALIFICATION.QUALITATIVE ? 'Cualitativa'
                            : item.subject_type_qualification == Constants.SUBJECTS.TYPE_QUALIFICATION.QUANTITATIVE ? 'Cuantitativa' : ''
                        }
                      </TableCell>
                      <TableCell>{item?.percentage ? formatNumber(item?.percentage) : '0'}</TableCell>
                      <TableCell>{item?.score_text ?? 'No evaluado'}</TableCell>
                      <TableCell>{item?.total_pond ?? 'No evaluado'}</TableCell>
                    </TableRow>
                  )
                )
              }
            }
          </TableBody>
        </Table>
      </ModalBody>
    </>
  )
}

const ModalDelete = ({ user, onClose, onDelete }) => {

  return (
    <>
      <ModalHeader className="flex flex-col gap-1">Confirmación</ModalHeader>
      <ModalBody>
        <p className="text-center">¿Estás seguro de retirar a este estudiante?</p>
        <p className="text-center font-medium">{user.student_fullname}</p>
      </ModalBody>
      <ModalFooter className="justify-evenly">
        <Button variant="light" onPress={onClose}>Cancelar</Button>
        <Button color="danger" onPress={onDelete}>Aceptar</Button>
      </ModalFooter>
    </>
  )
}


const useFetchTable = () => {
  const initialFilters = {
    page: 1,
    perPage: Constants.PER_PAGE,
    name: '',
    year: '',
    grade: '',
    section: '',
    student_id: '',
    lapse: '',
    type: TYPE.MAIN,
  };

  const initialPagination = {
    page: 1,
    pages: 1,
    total: 0,
    perPage: Constants.PER_PAGE,
  };
  const user = useSelector(state => state.user);
  const [data, setData] = useState([]);
  const [canFetch, setCanFetch] = useState(true);
  const [filters, setFilters] = useState(initialFilters);
  const [pagination, setPagination] = useState(initialPagination);
  const [schoolYears, setSchoolYears] = useState([]);
  const [studentGrades, setStudentGrades] = useState([]);
  const [studentSections, setStudentSections] = useState([]);
  const [schoolLapses, setSchoolLapses] = useState([]);

  const toSelect = (items) => items.map(x => ({ ...x, value: String(x.id), label: x.name }));

  const fetchData = async () => {

    if (!canFetch || !filters.year || !filters.grade || !filters.section || (!filters.lapse && filters.type !== TYPE.CERTIFICATION) || !filters.student_id || filters.type === TYPE.QUALIFICATIONS_BY_SECTION) {
      setData({});
      return
    }
    setCanFetch(false);

    try {
      const response = await SchoolService.SchoolReports.getReports({ ...filters, school_id: user.id });


      if (filters.type === TYPE.MAIN) {
        setCanFetch(true);
        return setData((prev) => ({
          ...prev,
          student: response?.student,
          parents: response?.parents,
        }))
      }

      if (filters.type === TYPE.ASSISTS) {
        setCanFetch(true);
        return setData((prev) => ({
          ...prev,
          assist: {
            fullName: response?.student?.fullname,
            grade: response?.student?.school_grade?.name,
            schoolDays: response?.totalLapsesDays,
            assistDays: response?.attendence?.presents,
            inassistDays: response?.attendence?.absents,
          },
        }))
      }

      if (filters.type === TYPE.QUALIFICATIONS) {
        setCanFetch(true);
        return setData((prev) => ({
          ...prev,
          student: response?.student,
          qualifications: {
            student_id: response?.student?.id,
            fullName: response?.student?.fullname,
            grade: response?.student?.school_grade?.name,
            document: `${response?.student?.document_type?.name} ${response?.student?.document}`,
            qualificationsAvg: response?.qualificationsAvg,
            maxQuantitativeScale: response?.maxQuantitativeScale,
            subjects: response?.results?.map(x => ({
              id: x.subject_id,
              name: x.subject_name,
              score: x.score,
              evaluated: x.evaluated,
              total_pond: x.total_pond,
              total_pond_avg: x.total_pond_avg,
              total_pond_desc: x.total_pond_desc,
            }))
          },
        }))
      }

      if (filters.type === TYPE.CONDUCT) {
        setCanFetch(true);
        const { student, ...rest } = response;
        return setData((prev) => ({
          ...prev,
          conduct: {
            fullName: response?.student?.fullname,
            document: response?.student?.document,
            director: `${response?.student?.director}`,
            municipality: `${response?.student?.municipality}`,
            data: rest,
          }
        }));
      }

      if (filters.type === TYPE.CERTIFICATION) {
        setCanFetch(true);
        return setData((prev) => ({
          ...prev,
          student: response?.student,
          certifications: {
            student_id: response?.student?.id,
            fullName: response?.student?.fullname,
            grade: response?.student?.school_grade?.name,
            document: `${response?.student?.document_type?.name} ${response?.student?.document}`,
            qualificationsAvg: response?.qualificationsAvg,
            maxQuantitativeScale: response?.maxQuantitativeScale,
            subjects: response?.results?.map(x => ({
              id: x.subject_id,
              name: x.subject_name,
              score: x.score,
              evaluated: x.evaluated,
              total_pond: x.total_pond,
              total_pond_avg: x.total_pond_avg,
              total_pond_desc: x.total_pond_desc,
            }))
          },
        }))
      }

    } catch (error) {
      setData([]);
      onError(String(error));
      setCanFetch(true);
    }
  }

  const getStudentScore = async (data) => {
    try {
      setCanFetch(false);
      const { student_id, subject_id, subjects_ids } = data;
      const response = await SchoolService.SchoolReports.getStudentsScore({
        student_id: student_id,
        subject_id: subject_id,
        subjects_ids: subjects_ids,
        school_id: user.id,
        ...filters
      })

      return response
    } catch (error) {
      onError(String(error));
    } finally {
      setCanFetch(true);
    }
  }

  const getStudentsGrades = async () => {
    if (!filters.student_id) return;
    try {
      const response = await SchoolService.SchoolReports.getStudentsGrades({ student_id: +filters.student_id, school_id: user.id });
      setStudentGrades(toSelect(response.grades));
    } catch (error) {
      onError(String(error));
    }
  }

  const getSelects = async () => {
    try {
      const selects = await UsersService.school.getSelects({ user_id: user.id });
      setSchoolYears(toSelect(selects.school_years));
      setSchoolLapses(toSelect(selects.lapses));
    } catch (error) {
      toast.error(String(error) || 'Ocurrió un error inesperado');
      return false;
    }
  }

  const getStudentsSections = async () => {
    if (!filters.grade || !filters.student_id) return;
    try {
      const sections = await SchoolService.SchoolReports.getStudentsSections({
        school_id: user.id,
        student_id: +filters.student_id,
        school_grade_id: +filters.grade,
      });
      setStudentSections(toSelect(sections));
      setCanFetch(true)
    } catch (error) {
      setData([]);
      onError(String(error));
    }
  }

  const getCurrentPagination = () => {
    // Truco para obtener el estado actualizado (pagination es mantenida con el estado actual por el componente Pagination)
    let pag;
    setPagination(s => {
      pag = s;
      return s;
    });
    return pag;
  }



  const canResetFilter = () => {
    const { page, perPage, ...initial } = initialFilters;
    const { page: _, perPage: __, ...current } = filters;
    const initFilter = JSON.stringify(initial);
    const currFilter = JSON.stringify(current);
    return initFilter !== currFilter;
  }

  const onError = (msg) => toast.error(msg);

  const reload = (inSamePage = false) => {
    setFilters(initialFilters);
    setData({})
  }

  const goToPage = (page) => {
    const pagination = getCurrentPagination();
    if (page >= 1 && page <= pagination.pages && page !== pagination.page) {
      setCanFetch(true);
      setFilters({ ...filters, page });
    }
  }

  const changePerPage = (perPage) => {
    setCanFetch(true);
    setFilters({ ...filters, perPage });
  }

  const filterBy = (value, target) => {
    setCanFetch(true);
    return setFilters({ ...filters, page: 1, [target]: value });
  }

  useEffect(() => {
    fetchData();
  }, [filters]);

  useEffect(() => {
    getSelects()
  }, [])

  useEffect(() => {
    getStudentsSections()
  }, [filters.grade])

  useEffect(() => {
    getStudentsGrades()
  }, [filters.student_id])

  return {
    canResetFilter: canResetFilter(),
    changePerPage,
    data,
    filterBy,
    filters,
    goToPage,
    studentGrades: studentGrades.filter(x => x.school_year_id === +filters.year),
    schoolLapses: schoolLapses.filter(x => x.school_year_id === +filters.year),
    isLoading: !canFetch,
    pagination,
    reload,
    schoolYears,
    studentSections,
    user,
    setFilters,
    getStudentScore
  }
}

// Para hacer fetch de todos los datos de la sección
const useQualificationsTable = () => {
  const initialFilters = {
    page: 1,
    perPage: Constants.PER_PAGE,
    year: '',
    grade: '',
    section: '',
  };

  const initialPagination = {
    page: 1,
    pages: 1,
    total: 0,
    perPage: Constants.PER_PAGE,
  };


  const user = useSelector(state => state.user);
  const [qualifications, setQualificacions] = useState([]);
  const [canFetch, setCanFetch] = useState(true);
  const [filters, setFilters] = useState(initialFilters);
  const [paginated, setPaginated] = useState(initialPagination);
  const [years, setYears] = useState([]);
  const [grades, setGrades] = useState([]);
  const [sections, setSections] = useState([]);
  const [lapses, setLapses] = useState([]);

  const toSelect = (items) => items.map(x => ({ ...x, value: String(x.id), label: x.name }));


  const fetchData = async () => {
    if (!filters.year || !filters.grade || !filters.section) return;
    setCanFetch(false);
    try {
      const response = await SchoolService.SchoolReports.getSectionQualifications({ ...filters, school_id: user.id });
      const { data, ...rest } = response;
      setQualificacions(data);
      setPaginated(rest);
      setCanFetch(true);
    } catch (error) {
      onError(String(error));
    }
  }

  const downloadData = async () => {
    if (!filters.year || !filters.grade || !filters.section) return;
    setCanFetch(false);
    // try {
    //   const response = await SchoolService.SchoolReports.getSectionQualifications({ ...filters, school_id: user.id, download: true });
    //   if (response.url) {
    //     const link = document.createElement('a');
    //     link.href = response.url;
    //     link.download = response.url.split('/').pop();
    //     link.target = '_blank';
    //     link.click();
    //     link.remove();
    //   }
    //   setCanFetch(true);
    // } catch (error) {
    //   onError(String(error));
    // }

    try {
      const response = await SchoolService.SchoolReports.buildQualificationsExcel(
        { 
          ...filters, 
          _user_id: user.id, 
          school_id: user.id, 
          download: true 
        }
      );
      if (response.url) {
        const link = document.createElement('a');
        link.href = response.url;
        link.download = response.url.split('/').pop();
        link.target = '_blank';
        link.click();
        link.remove();
      }
      setCanFetch(true);
    } catch (error) {
      onError(String(error));
    }
  }

  const downloadCertification = async () => {
    setCanFetch(false);
    try {
      const response = await SchoolService.SchoolReports.downloadStudentCertificate({ ...filters, school_id: user.id });
      if (response.url) {
        const link = document.createElement('a');
        link.href = response.url;
        link.download = response.url.split('/').pop();
        link.target = '_blank';
        link.click();
        link.remove();
      }
      setCanFetch(true);
    } catch (error) {
      onError(String(error));
      setCanFetch(true);
    }
  }

  const downloadQualificationsCertified = async () => {
    setCanFetch(false);
    try {
      const response = await SchoolService.SchoolReports.downloadStudentQualificationsCertified({ ...filters, school_id: user.id });
      if (response.url) {
        const link = document.createElement('a');
        link.href = response.url;
        link.download = response.url.split('/').pop();
        link.target = '_blank';
        link.click();
        link.remove();
      }
      setCanFetch(true);
    } catch (error) {
      onError(String(error));
    }
  }

  const getSelects = async () => {
    try {
      const selects = await UsersService.school.getSelects({ user_id: user.id });
      setYears(toSelect(selects.school_years));
      setGrades(toSelect(selects.school_grades));
      setLapses(toSelect(selects.lapses));
    } catch (error) {
      toast.error(String(error) || 'Ocurrió un error inesperado');
      return false;
    }
  }

  const fetchSections = async () => {
    if (!filters.grade) return;
    try {
      const sections = await SchoolService.schoolAdmin.getSections({
        school_id: user.id,
        school_grade_id: +filters.grade
      });
      setSections(toSelect(sections));
      setCanFetch(true)
    } catch (error) {
      setQualificacions([]);
      onError(String(error));
    }
  }

  const getCurrentPagination = () => {
    // Truco para obtener el estado actualizado (pagination es mantenida con el estado actual por el componente Pagination)
    let pag;
    setPaginated(s => {
      pag = s;
      return s;
    });
    return pag;
  }



  const resetFilter = () => {
    const { page, perPage, ...initial } = initialFilters;
    const { page: _, perPage: __, ...current } = filters;
    const initFilter = JSON.stringify(initial);
    const currFilter = JSON.stringify(current);
    return initFilter !== currFilter;
  }

  const onError = (msg) => toast.error(msg);

  const toPage = (page) => {
    const pagination = getCurrentPagination();
    if (page >= 1 && page <= pagination.pages && page !== pagination.page) {
      setCanFetch(true);
      setFilters({ ...filters, page });
    }
  }

  const reloadQualifications = (inSamePage = false) => {
    setCanFetch(true);
    if (!inSamePage) setFilters(initialFilters);
    else fetchData();
    setQualificacions([])
  }

  const perPage = (perPage) => {
    setCanFetch(true);
    setFilters({ ...filters, perPage });
  }

  const onFilter = (value, target) => {
    setCanFetch(true);
    return setFilters({ ...filters, page: 1, [target]: value });
  }

  const deleteStudent = async (id) => {
    if (!canFetch) return;
    setCanFetch(false);

    try {
      await UsersService.school.destroyStudent(id)
      toast.success('Estudiante retirado con éxito');
      fetchData();

    } catch (error) {
      onError(String(error));
    }
    setCanFetch(true);
  }

  const changeStatus = async (item, value) => {

    if (item.final_average >= 9.5 && +value === Constants.APPROVED_STATUS.FAILED) {
      toast.error('Estudiante no puede ser reprobado porque su promedio es superior a 9.5');
      return
    }

    if (item.final_average < 9.5 && +value === Constants.APPROVED_STATUS.APPROVED) {
      toast.error('Estudiante no puede ser aprobado porque su promedio es inferior a 9.5');
      return
    }


    try {
      await SchoolService.SchoolReports.setStudentStatus({
        student_id: item.student_id,
        year: +filters.year,
        status: value,
      })
      toast.success('Estado actualizado con éxito');
      fetchData()
    } catch (error) {
      onError(String(error))
    }
  }

  const changeGrade = async (item, value) => {
    try {
      await SchoolService.SchoolReports.setPromotion({
        student_id: item.student_id,
        year: +filters.year,
        next_grade_id: value,
      })
      toast.success('Estudiante promovido con éxito');
      fetchData()
    } catch (error) {
      onError(String(error))
    }
  }



  useEffect(() => {
    getSelects()
  }, [])

  useEffect(() => {
    fetchSections()
  }, [filters.grade])

  useEffect(() => {
    fetchData()
  }, [filters])

  return {
    qualifications,
    downloadQualifications: downloadData,
    downloadCertification,
    downloadQualificationsCertified,
    resetFilter: resetFilter(),
    toPage,
    perPage,
    onFilter,
    loading: !canFetch,
    paginated,
    qualificatioFilters: filters,
    years,
    grades: grades.filter(x => x.school_year_id === +filters.year),
    lapses: lapses.filter(x => x.school_year_id === +filters.year),
    sections,
    reloadQualifications,
    deleteStudent,
    changeStatus,
    changeGrade
  }
}


export default Students;
